import { render, staticRenderFns } from "./AssetAssignUser.vue?vue&type=template&id=2639b84e&"
import script from "./AssetAssignUser.vue?vue&type=script&lang=js&"
export * from "./AssetAssignUser.vue?vue&type=script&lang=js&"
import style0 from "./AssetAssignUser.vue?vue&type=style&index=0&id=2639b84e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports